module.exports = "https://coursera_assets.s3.amazonaws.com/images/7fd617357ece835ed674d3ed0014c29a.png";